import styled, { useTheme } from 'styled-components';
import { LXh5 } from '../../texts/lxText';

interface LXSearchButtonProps {
  onClick: () => void;
}

const LXSearchInnerButton = styled.div`
  height: 48px;
  width: 93px;
  cursor: pointer;
  border-radius: 300px;
  background-color: ${(props) => props.theme.colors.grayIcon};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    opacity: 0.8;
  }
`;

const LXSearchButton = (props: LXSearchButtonProps) => {
  const theme = useTheme();

  return (
    <LXSearchInnerButton onClick={props.onClick}>
      <LXh5 color={theme.colors.white}>{theme.texts.search}</LXh5>
    </LXSearchInnerButton>
  );
};

export default LXSearchButton;
